<template>

  <v-data-table
    :headers="headers"
    :items="getItems"
    :search="search"
    :page.sync="page"
    :items-per-page="itemsPerPage"
    sort-by="nombre"
    class="elevation-1"
    @page-count="pageCount = $event"
  >
    <template v-slot:top >
      <v-toolbar flat color="white" >
        <v-toolbar-title>{{title}}</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar..."
        single-line
        hide-details
      ></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >NUEVO</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <form>
                  
                    <v-text-field class="mb-0" outlined dense v-model="editedItem.nombrecomercial" label="Nombre Comercial"></v-text-field>
                                    
                  
                    <v-text-field class="datos" outlined dense v-model="editedItem.propietario" label="Propietario"></v-text-field>
                  
                    <v-text-field class="datos" outlined dense v-model="editedItem.direccion" label="Direccion"></v-text-field>
                    <v-text-field class="datos" outlined dense v-model="editedItem.telefono" label="Telefono"></v-text-field>
                  <v-row style="margin-top:-15px">
                    <v-col cols="4">
                      <v-text-field type="number" dense outlined v-model="editedItem.codigo" label="Codigo Establecimiento"></v-text-field>
                    </v-col> 
                    <v-col cols="4">
                      <v-text-field outlined dense v-model="editedItem.nit" label="Nit"></v-text-field>
                    </v-col>   
                    <v-col cols="4">
                      <v-autocomplete  outlined dense v-model="editedItem.codregimen" :items="regimenes" clearable hide-selected item-text="nombre" item-value="codigo" label="Regimen Tributario" >
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row style="margin-top:-25px">
                    <v-col cols="4">
                      <v-text-field outlined dense v-model="editedItem.departamento" label="Departamento"></v-text-field>
                    </v-col> 
                    <v-col cols="5">
                      <v-text-field outlined dense v-model="editedItem.municipio" label="Municipio"></v-text-field>
                    </v-col>   
                    <v-col cols="3">
                      <v-text-field type="number" outlined dense v-model="editedItem.codigopostal" label="Codigo Postal"></v-text-field>
                    </v-col>  
                  </v-row>
                  <v-row style="margin-top:-15px">
                    <v-col cols="6">
                      <v-text-field type="number" outlined dense v-model="editedItem.tipofrase" label="Tipo Frase"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field type="number" outlined dense v-model="editedItem.codigoescenario" label="Codigo Escenario"></v-text-field>
                    </v-col>
                  </v-row>
                  <v-text-field dense outlined v-model="editedItem.token" label="Token" style="margin-top:-15px"></v-text-field>     
                </form>  
                <v-divider></v-divider>             
              </v-container>
            </v-card-text>
            <v-card-actions style="margin-top:-45px">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small  class="mr-2"  @click="editItem(item)"  v-if="item.estado == 'Activo'" >
        mdi-pencil
      </v-icon>
      <v-icon small @click="deleteItem(item.idestablecimiento)" v-if="item.estado == 'Activo'">
        mdi-delete
      </v-icon>
      <v-btn color="red" small v-if="item.estado !== 'Activo'" @click="cambiarestado('Activo',item.idestablecimiento)" x-small dark>
        Activar
      </v-btn>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Recargar</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
     data: () => ({
      title:'ESTABLECIMIENTOS',
      page:1,
      itemsPerPage: 10,
      search:'',
      estado:false,
      dialog: false,
      headers: [       
        { text: 'Codigo', value: 'codigo' },
        { text: 'Nombre Comercial', value: 'nombrecomercial' },
        { text: 'Propietario',align: 'center', value: 'propietario' },      
        { text: 'Direccion',align: 'center', value: 'direccion' },      
        { text: 'Nit',align: 'center', value: 'nit' },      
        { text: 'Regimen',align: 'center', value: 'codregimen' },      
        { text: 'Estado',align: 'center', value: 'estado',sortable: false, },
        { text: 'Actions',align: 'center', value: 'actions', sortable: false },
      ],
      itemslist: [],
      regimenes:[
        {codigo:'GEN',nombre:'GENERAL'},
        {codigo:'PEQ',nombre:'PEQUEÑO CONTRIBUYENTE'},
        {codigo:'EXE',nombre:'EXENTO'}
      ],
      editedIndex: -1,
      editedItem: {
          nombrecomercial: "",
          propietario: "",
          direccion: "",
          codigo: 1,
          nit: "",
          telefono: "",
          codregimen: "GEN",
          municipio: "JALAPA",
          departamento: "JALAPA",
          codigopostal: 21001,
          tipofrase:1,
          codigoescenario:1
      },
      defaultItem: {
        nombrecomercial: "",
        propietario: "",
        direccion: "",
        codigo: 1,
        nit: "",
        telefono: "",
        codregimen: "GEN",
        municipio: "JALAPA",
        departamento: "JALAPA",
        codigopostal: 21001,
        tipofrase:1,
        codigoescenario:1
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo Registro' : 'Editar Registro'
      },
      getItems(){
        return this.$store.getters.getAllEstablecimientos
      },
      getTokenUser(){
        return this.$store.getters.getTokenUser
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    async created () {
      await this.initialize()
    },

    methods: {
      async initialize () {
       await this.$store.dispatch('setAllEstablecimientos')       
      }, 
      editItem (item) {
        this.editedIndex = this.getItems.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (idestablecimiento) {
        
        Swal.fire({
          title: 'Esta Seguro?',
          text: "El registro será desactivado!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, Desactivar!',
          cancelButtonText: 'Cancelar!'
        }).then((result) => {
          if (result.isConfirmed) {
            //Procedimiento para eliminarlo
            this.cambiarestado('Eliminado',idestablecimiento)
          }
        })
        
      },
      async cambiarestado(estado,idestablecimiento) {
        await axios.put(`${this.$store.state.urlapi}/establecimientos/${idestablecimiento}`,{estado:estado},this.getTokenUser)
          .then(() => {
            this.alertDone();
            this.initialize();
          });
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.parsearValores()
        if (this.editedIndex > -1) {       
          this.putItem()
        } else {
          this.postItem()
        }
        this.close()
      },
      postItem(){
        axios.post(`${this.$store.state.urlapi}/establecimientos/`,this.editedItem,this.getTokenUser).then(()=>{                
          this.alertDone()
          this.initialize()          
        })
      },
      putItem(){    
          
       axios.put(`${this.$store.state.urlapi}/establecimientos/${this.editedItem.idestablecimiento}`,this.editedItem,this.getTokenUser).then(()=>{         
          this.alertDone()
          this.initialize()          
        })
        
      },
    parsearValores(){
        this.editedItem.codigo = parseInt(this.editedItem.codigo)  
        this.editedItem.codigopostal = parseInt(this.editedItem.codigopostal)  
    },
      //Notificaciones Swal
      alertDone(){
        Swal.fire({
          icon: 'success',
          title: 'Realizado',
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    
}
</script>
<style scoped>
.datos input {
  padding: 30px;
}
</style>